import {
  Box,
  Flex,
  VStack,
  Input,
  Select,
  Button,
  FormControl,
  FormLabel,
  Heading,
  IconButton,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  Text,
  Tag,
  Avatar,
  Grid,
  GridItem,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Textarea,
  Tabs,
  TabList,
  Tab,
  HStack,
} from "@chakra-ui/react";
import profileFrame from "../../assets/images/profileFrame.png";
import { node } from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Loader from "../../components/Loader/Loader";
import {
  getUserDetail,
  updateUserProfile,
} from "../../actions/user/userActions";
const sectionStyle = {
  marginBottom: "32px",
};

const headingStyle = {
  fontSize: "16px",
  fontWeight: 500,
  marginBottom: "8px",
};
const tagContainerStyle = {
  display: "flex",
  gap: "8px",
  flexWrap: "wrap",
};

const tagStyle = {
  padding: "4px 10px",
  backgroundColor: "#f3f4f6",
  borderRadius: "6px",
  fontSize: "14px",
};
const cardStyle1 = {
  padding: "5px",
  borderRadius: "8px",
  marginBottom: "10px",
};
const cardStyle = {
  backgroundColor: "#f9fafb",
  padding: "5px",
  borderRadius: "8px",
  marginBottom: "10px",
};

const profileHeaderStyle = {
  textAlign: "center",
};

const initiatives = [
  {
    initiative: "Improve cashflow",
    status: "Open",
    contributor: "Ajay Nagpal",
    additionalContributors: 3,
    function: "Operations",
  },
  {
    initiative: "Optimize production by 5%",
    status: "Open",
    contributor: "Ajay Nagpal",
    additionalContributors: 2,
    function: "Operations",
  },
];

const tableStyles = {
  container: {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: "0",
    backgroundColor: "#F8F8F8",
    border: "none",
  },
  headerCell: {
    textAlign: "left",
    padding: "12px 16px",
    color: "#6B7280",
    fontWeight: 500,
    fontSize: "14px",
    backgroundColor: "#F9FAFB",
    borderBottom: "none",
  },
  cell: {
    padding: "16px",
    fontSize: "14px",
    borderBottom: "none",
  },
  statusBadge: {
    display: "inline-block",
    padding: "4px 12px",
    backgroundColor: "#F3F4F6",
    borderRadius: "16px",
    fontSize: "12px",
    color: "#374151",
  },
  contributorCell: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  avatar: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    backgroundColor: "#E5E7EB",
  },
  contributorText: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
};

const buttonContainerStyle = {
  marginTop: "32px",
  display: "flex",
  justifyContent: "flex-end",
  gap: "16px",
};

const buttonStyle = {
  padding: "8px 24px",
  backgroundColor: "#374151",
  color: "white",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer",
};
const MyProfile = () => {
  const dispatch = useDispatch();
  const [previewUrl, setPreviewUrl] = useState(null);
  const roles = ["Leadership", "Management", "Employee"];
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  
  const [imageFile, setImageFile] = useState(null);
  const [formData, setFormData] = useState({
    pswd: "",
    cnfPswd: "",
    designation: "",
    reachOutEmail: "",
    linkedin: "",
    facebook: "",
    twitter: "",
  });

  const { loading: userProfileLoading, data: userProfileData } = useSelector(
    (state) => state.userProfileReducer
  );

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setPreviewUrl(url);
      setImageFile(file);
    }
  };

  const handleSubmit = () => {
    console.log(formData);
    if (
      formData.pswd &&
      formData.cnfPswd &&
      formData.pswd !== formData.cnfPswd
    ) {
      return;
    }
    const data = new FormData();
    data.append("role", roles[selectedTabIndex]);
    data.append("designation", formData.designation);
    data.append("reachOutEmail", formData.reachOutEmail);
    data.append("linkedin", formData.linkedin);
    data.append("facebook", formData.facebook);
    data.append("twitter", formData.twitter);
    if (formData.pswd) {
      data.append("password", formData.pswd);
    }
    if (imageFile) {
      data.append("file", imageFile);
    }
    
    dispatch(updateUserProfile(data));
  };

  const { loading: userLoading, data: userData } = useSelector(
    (state) => state.userDetailReducer
  );

  useEffect(() => {
    dispatch(getUserDetail());
  }, []);

  useEffect(() => {
    if (!userLoading && userData) {
      setFormData(userData);
      setPreviewUrl(userData?.profileImage || null);
      if(userData.role){
        const roleIndex = roles.indexOf(userData.role);
        setSelectedTabIndex(roleIndex);
      }
    }
  }, [userLoading, userData]);

  const handleTabChange = (index) => {
    setSelectedTabIndex(index);
  };

  return (
    <>
      {userLoading ? (
        <Loader />
      ) : (
        <Box m={8}>
          <Grid
            templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)" }}
            gap={8}
          >
            <GridItem colSpan={1}>
              <VStack spacing={{ base: 4, md: 6 }} align="stretch">
                {/* Name */}
                <FormControl>
                  <FormLabel fontSize={{ base: "sm", md: "md" }}>
                    Name
                  </FormLabel>
                  <Input
                    value={userData?.full_name}
                    size={{ base: "sm", md: "md" }}
                    disabled={"true"}
                  />
                </FormControl>
                <Flex justifyContent="space-between" alignItems="center" mb={6}>
                  <Box mb={6}>
                    <Text fontWeight="medium" mb={2}>
                      Your Role
                    </Text>
                    <Tabs
                      variant="unstyled"
                      mb={4}
                      index={selectedTabIndex}
                      onChange={handleTabChange}
                    >
                      <TabList>
                        {roles.map((role, idx) => (
                          <Tab
                            bg={
                              idx === selectedTabIndex ? "gray.700" : "gray.100"
                            }
                            color={
                              idx === selectedTabIndex ? "white" : "gray.600"
                            }
                            borderRadius="md"
                            mr={2}
                            _selected={{ bg: "gray.700", color: "white" }}
                          >
                            {role}
                          </Tab>
                        ))}
                      </TabList>
                    </Tabs>
                    {/* Education */}
                    <FormControl>
                      <FormLabel>Your Designation</FormLabel>
                      <Input
                        name="designation"
                        placeholder="Your Designation"
                        onChange={handleChange}
                        value={formData?.designation}
                      />
                    </FormControl>
                  </Box>
                  <Box mb={6}>
                    {/* Avatar */}
                    <Input
                      type="file"
                      id="imageUpload"
                      style={{ display: "none" }}
                      onChange={handleImageUpload}
                      accept="image/*"
                    />
                    <label htmlFor="imageUpload">
                      <Box as="span" cursor="pointer">
                        <Avatar size="lg" src={previewUrl} alt="Preview" />
                      </Box>
                    </label>
                  </Box>
                </Flex>

                <FormControl>
                  <FormLabel>Reach Out E-Mail</FormLabel>
                  <Input
                    name="reachOutEmail"
                    value={formData.reachOutEmail}
                    onChange={handleChange}
                    placeholder="Reach Out E-Mail"
                    bg="gray.50"
                  />
                </FormControl>

                {/* Experience */}
                <FormControl>
                  <FormLabel>LinkedIn (Optional)</FormLabel>
                  <Input
                    name="linkedin"
                    value={formData.linkedin}
                    onChange={handleChange}
                    placeholder="LinkedIn (Optional)"
                    bg="gray.50"
                  />
                </FormControl>
                {/* Experience */}
                <FormControl>
                  <FormLabel>Facebook (Optional)</FormLabel>
                  <Input
                    name="facebook"
                    value={formData.facebook}
                    onChange={handleChange}
                    placeholder="Facebook (Optional)"
                    bg="gray.50"
                  />
                </FormControl>
                {/* Experience */}
                <FormControl>
                  <FormLabel>Twitter/X (Optional)</FormLabel>
                  <Input
                    name="twitter"
                    value={formData.twitter}
                    onChange={handleChange}
                    placeholder="Twitter/X (Optional)"
                    bg="gray.50"
                  />
                </FormControl>
              </VStack>
            </GridItem>

            <GridItem colSpan={1}>
              <VStack spacing={6} align="stretch">
                <Flex justifyContent="space-between" alignItems="start" mb={6}>
                  <Heading size="md">Account Settings</Heading>
                </Flex>
                <FormControl>
                  <FormLabel>Email</FormLabel>
                  <Input
                    name="email"
                    value={userData?.email}
                    placeholder="Email"
                    bg="gray.50"
                    disabled={"true"}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Password</FormLabel>
                  <Input
                    name="pswd"
                    value={formData.pswd}
                    onChange={handleChange}
                    placeholder="Password"
                    bg="gray.50"
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Confirm Password</FormLabel>
                  <Input
                    name="cnfPswd"
                    value={formData.cnfPswd}
                    onChange={handleChange}
                    placeholder="Confirm Password"
                    bg="gray.50"
                  />
                </FormControl>
              </VStack>
            </GridItem>
          </Grid>
          <Flex justify="center" mt={10}>
            <Button
              colorScheme="blackAlpha"
              bg="black"
              size="md"
              px={10}
              _hover={{ bg: "gray.800" }}
              onClick={handleSubmit}
            >
              {userProfileLoading ? "Loading..." : "Submit"}
            </Button>
          </Flex>
        </Box>
      )}
    </>
  );
};

export default MyProfile;
